import { getProjectContentLinks, getStartWatchingList } from '@/services/ProjectsService'
import {
  mapProjectsToLogoContentLinks,
  mapStartWatchingToContentLinks,
} from '@/services/RenderService/mapCollectionDataSources'
import { LinkViewModel, MapDataOptions } from '@/services/RenderService/types'

export async function getBrandLogos(options?: MapDataOptions): Promise<LinkViewModel[]> {
  const projectLinks = await getProjectContentLinks()
  return mapProjectsToLogoContentLinks(projectLinks, options)
}

export async function getStartWatchingEpisodes(options?: MapDataOptions): Promise<LinkViewModel[]> {
  const projects = await getStartWatchingList()
  return mapStartWatchingToContentLinks(projects, options)
}

//export async function getStartWatchingTitleIds(): Promise<string[]> {}
